import { getEntity } from 'data'
import {
  getOrganizationId,
  isPaid,
  hasFeatureFlag,
} from 'data/organizations/selectors'

const NOTE_NEARING_LIMIT_RATIO = 0.7 // 70%, ie 35/50 notes

export function getOrganizationResourcesUsage(state) {
  const organizationId = getOrganizationId(state)
  return getEntity(state, 'OrganizationResourcesUsage', organizationId)
}

export function getNoteResourcesUsage(state) {
  const resourceUsage = getOrganizationResourcesUsage(state)
  if (!resourceUsage) {
    return {} // assume limit not to be reached
  }
  const { notes } = resourceUsage.toJS()

  return notes
}

export function hasOrganizationReachedNotesUsageRation(state, ratio) {
  const resourcesUsage = getNoteResourcesUsage(state)
  if (!resourcesUsage || resourcesUsage.limit === 0) {
    return false
  }
  return resourcesUsage.current / resourcesUsage.limit >= ratio
}

export function isNotesUsageLimitReached(state) {
  if (hasFeatureFlag(state, 'bypass-limits')) {
    return false
  }

  if (isPaid(state)) {
    return false
  }

  return hasOrganizationReachedNotesUsageRation(state, 1)
}

export function isNotesUsageLimitNear(state) {
  if (hasFeatureFlag(state, 'bypass-limits')) {
    return false
  }

  if (isPaid(state)) {
    return false
  }

  return hasOrganizationReachedNotesUsageRation(state, NOTE_NEARING_LIMIT_RATIO)
}
